import { mapState } from 'vuex'
import Members from '../Global/Members'

export default {
    name: 'Members',

    extends: Members,

    data () {
        return {
            isLoading: true
        }
    },

    created () {
        Promise.all([
            this.$store.dispatch('job/fetchMembers')
        ]).then(() => {
            this.isLoading = false
        })
    },

    watch: {
        jobMembers: {
            immediate: true,
            handler (members) {
                this.members = members
            }
        }
    },

    methods: {
        addMember (user) {
            if (this.isBusy) {
                return
            }

            this.isBusy = true
            this.$store.dispatch('job/addMember', user).then(() => {
                this.search = ''
                this.isBusy = false
            })

            this.close()
        },

        removeMember (member) {
            if (this.isBusy) {
                return
            }

            this.isBusy = true
            this.$store.dispatch('job/removeMember', member).then(() => {
                this.isBusy = false
            })

            this.close()
        }
    },

    computed: {
        ...mapState('job', {
            job: 'job',
            jobMembers: 'members'
        })
    }
}
